export default "./dist/stdassets/images/icons/zoom-dynamic.png";